module.exports = __webpack_public_path__ + "static/img/meiti3.9113f913.png";